import { useRoute } from '#imports'
import { computed } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

export function useGoogleShopping() {
  const route = useRoute()
  const experiments = useExperiments()

  const isFromGoogleShopping = computed(
    () => route.query.utm_source === 'google',
  )

  const isLpoActive = computed(
    () =>
      isFromGoogleShopping.value &&
      route.query.utm_medium === 'cpc' &&
      typeof route.query.utm_campaign === 'string' &&
      route.query.utm_campaign.includes('SHOP') &&
      experiments['experiment.lpoGoogleShoppingConfigurator'] === 'enabled',
  )

  return { isFromGoogleShopping, isLpoActive }
}
